import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { GoogleAdManagerConnectionDTO } from './types'

export const GOOGLE_AD_MANAGER_CONNECTION_FRAGMENT: TypedDocumentNode<GoogleAdManagerConnectionDTO> = gql`
  fragment GoogleAdManagerConnectionFragment on GamConnectionOrder {
    errorMessage
    id
    status
    updatedAt
  }
`
